import { render } from "./VacationTable.vue?vue&type=template&id=bfc87e74"
import script from "./VacationTable.vue?vue&type=script&lang=js"
export * from "./VacationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__